import { defineComponent } from 'vue'

export interface RequestedSuggestedAction {
  key: string
  params: Record<string, any>
  docType?: string
}

/**
 * Lets a view run the direct suggested actions whose UI it owns (a modal, a
 * menu): the assistant's bubble requests one through the store, the view that
 * declares its key handles it (on mount too, when the bubble navigated to it)
 * in `handleSuggestedAction(request)`.
 */
export function suggestedActionHandler(keys: string[]) {
  return defineComponent({
    computed: {
      requestedSuggestedAction(): RequestedSuggestedAction | null {
        return this.$store.getters['aiAssistant/requestedSuggestedAction']
      }
    },
    watch: {
      requestedSuggestedAction: {
        immediate: true,
        handler(request: RequestedSuggestedAction | null) {
          if (!request || !keys.includes(request.key)) {
            return
          }
          this.$store.commit('aiAssistant/clearRequestedSuggestedAction')
          ;(this as any).handleSuggestedAction(request)
        }
      }
    }
  })
}
